<template>
	<div class="d-flex justify-center" style="flex:1;">
		<v-btn
			outlined
			@click="() => agenda.calendar && agenda.calendar.toToday()"
		>
			Hoje
		</v-btn>
		<FiltroDaAgenda v-model="filtro">
			<template #default="{ on }">
				<v-btn
					class="ml-2"
					outlined
					v-on="on"
				>
					Filtros
				</v-btn>
			</template>
		</FiltroDaAgenda>
		<v-btn
			outlined
			style="width: 100px;"
			@click="trocarOpcao"
			class="px-3 justify-start ml-2"
		>
			<v-icon left> mdi-label </v-icon>
			{{ opcao.text }}
		</v-btn>
	</div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { Filtro } from '@/modules/AgendaModule'
import FiltroDaAgenda from '@/components/FiltroDaAgenda.vue'
import { agenda } from '@/store'

interface Opcao {
	text: string,
	value: 'grau' | 'tipo',
}

const opcoes: Opcao[] = [
	{
		text: 'Grau',
		value: 'grau',
	},
	{
		text: 'Tipo',
		value: 'tipo',
	},
]

const tipoDaLabel = computed({
	get: () => agenda.tipoDaLabel,
	set: (tipo: 'grau' | 'tipo') => agenda.setTipoDaLabel(tipo),
})

const opcao = computed(() => opcoes
	.find(({value}) => value === tipoDaLabel.value) as Opcao)

function trocarOpcao() {
	const indice = opcoes
		.findIndex(({value}) => value === tipoDaLabel.value)
	tipoDaLabel.value = indice !== -1
		? opcoes[(indice + 1) % 2].value
		: 'grau'
}

const filtro = computed({
	get: () => agenda.filter,
	set: (novoFiltro: Filtro) => agenda.setFilter(novoFiltro),
})
</script>
